import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, APP_BOOTSTRAP_LISTENER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { CustomDialogComponent } from './custom-dialog/custom-dialog.component';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from './services/auth-guard.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { WindowpopupComponent } from './windowpopup/windowpopup.component';
import { SharepopupComponent } from './sharepopup/sharepopup.component';
import { AuthHttpInterceptor } from './interceptors/authHttpInterceptor';
import { HomePopupComponent } from './home-popup/home-popup.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { BookmarkedComponent } from './bookmarked/bookmarked.component';
import { MyvideosComponent } from './myvideos/myvideos.component';
import { CacheService } from './services/cache.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SignupComponent } from './signup/signup.component';
import { SubmitComponent } from './submit/submit.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { ClipboardModule } from 'ngx-clipboard';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AdminComponent } from './admin/admin.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { BlogComponent } from './blog/blog.component';
import { VimeoService } from './services/vimeo.service';
import { AdminService } from './services/admin.service';
import { AdminPendingComponent } from './admin-pending/admin-pending.component';
import { AdminApprovedComponent } from './admin-approved/admin-approved.component';
import { AdminRejectedComponent } from './admin-rejected/admin-rejected.component';
import { AdminUploadedComponent } from './admin-uploaded/admin-uploaded.component';
import { AdminOfflineComponent } from './admin-offline/admin-offline.component';
import { VerifyComponent } from './verify/verify.component';
import { YourTipJarComponent } from './your-tip-jar/your-tip-jar.component';
import { StripePaymentComponent } from './stripe-payment/stripe-payment.component';
import { NgxStripeModule } from 'ngx-stripe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { GetPaymentService } from './services/get-payment.service';
import { AudioPlayerComponent } from './audio-player/audio-player.component';
import { environment } from 'src/environments/environment';
import { PaymentComponent } from './payment/payment.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ThanksPopupComponent } from './thanks-popup/thanks-popup.component';
import { BookmarkedThanksComponent } from './bookmarked-thanks/bookmarked-thanks.component';
import { AdminEditComponent } from './admin-edit/admin-edit.component';
import { MapSearchComponent } from './map-search/map-search.component';
import { SubscriptionsComponent } from './subscriptions/subscriptions.component';
import { PrimeGuard } from './services/prime.guard';
import { AdminGuard } from './services/admin.guard';
import { WindowComponent } from './window/window.component';
import { LondonCityVideosComponent } from './cities-filtered-videos/london-city-videos/london-city-videos.component';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { NewYorkCityVideoComponent } from './cities-filtered-videos/new-york-city-video/new-york-city-video.component';
import { AdminGdriveComponent } from './admin-gdrive/admin-gdrive.component';
import { SafePipe } from './pipes/safe.pipe';
import { FilterPipe } from './pipes/filter.pipe';
import { EditProfileComponent } from './user-setting/edit-profile/edit-profile.component';
import { ChangePasswordComponent } from './user-setting/change-password/change-password.component';
import { UserSettingComponent } from './user-setting/user-setting/user-setting.component';
import { AllAccessComponent } from './user-setting/all-access/all-access.component';
import { ChangePaymentModeComponent } from './user-setting/change-payment-mode/change-payment-mode.component';
import { DatePipe } from '@angular/common';
import { AllaccessguardService } from './services/allaccessguard.service';
import { CloseAccountComponent } from './user-setting/close-account/close-account.component';
import { UserService } from './services/user.service';
import { Auth } from 'aws-amplify';
import { MatMenuModule } from '@angular/material/menu';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MyWindowEditComponent } from './my-window-edit/my-window-edit.component';
import { TermsComponent } from './terms/terms.component';
import { SessionService } from './services/session.service';
import { AdminCuratedComponent } from './admin-curated/admin-curated.component';
import { AlertMessageComponent } from './alert-message/alert-message.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { GiftComponent } from './gift/gift.component';
import { GiftCheckoutComponent } from './gift-checkout/gift-checkout.component';
import { GiftSuccessComponent } from './gift-success/gift-success.component';
import { AdminFailedComponent } from './admin-failed/admin-failed.component';
import { AboutGazeComponent } from './about-gaze/about-gaze.component';
import { GazePolicyComponent } from './gaze-policy/gaze-policy.component';
import { GazeDeleteAccountComponent } from './gaze-delete-account/gaze-delete-account.component';
import { GazeSupportComponent } from './gaze-support/gaze-support.component';
// import { HelperService } from './services/helper.service';


// export function userServiceLoader(userService: UserService) {
//   return () => {
//     return Auth.currentAuthenticatedUser()
//       .then(() => {
//         return userService.getUserDataFromDb().then(() => {
//           if (!userService.userData.isPrime) {
//             loadScript("https://cdn.fuseplatform.net/publift/tags/2/3701/fuse.js");
//           }
//         });
//       })
//       .catch((err) => {
//         loadScript("https://cdn.fuseplatform.net/publift/tags/2/3701/fuse.js");
//         return Promise.resolve(); // Ensure the promise resolves
//       });
//   };
// }

function loadScript(src: string) {
  const script = document.createElement('script');
  script.src = src;
  script.id = "ads-script-fuse";
  script.async = true;
  document.head.appendChild(script);
}


@NgModule({ 
    declarations: [
        AppComponent,
        HomeComponent,
        WindowComponent,
        CustomDialogComponent,
        LoginComponent,
        WindowpopupComponent,
        SharepopupComponent,
        HomePopupComponent,
        UserProfileComponent,
        BookmarkedComponent,
        MyvideosComponent,
        SignupComponent,
        SubmitComponent,
        AdminComponent,
        BlogComponent,
        AdminPendingComponent,
        AdminApprovedComponent,
        AdminRejectedComponent,
        AdminUploadedComponent,
        AdminOfflineComponent,
        VerifyComponent,
        YourTipJarComponent,
        StripePaymentComponent,
        AudioPlayerComponent,
        PaymentComponent,
        ThanksPopupComponent,
        BookmarkedThanksComponent,
        AdminEditComponent,
        MapSearchComponent,
        SubscriptionsComponent,
        LondonCityVideosComponent,
        UserMenuComponent,
        NewYorkCityVideoComponent,
        AdminGdriveComponent,
        SafePipe,
        FilterPipe,
        EditProfileComponent,
        ChangePasswordComponent,
        UserSettingComponent,
        AllAccessComponent,
        ChangePaymentModeComponent,
        CloseAccountComponent,
        MyWindowEditComponent,
        TermsComponent,
        AdminCuratedComponent,
        AlertMessageComponent,
        ConfirmationComponent,
        GiftComponent,
        GiftCheckoutComponent,
        GiftSuccessComponent,
        AdminFailedComponent,
        AboutGazeComponent,
        GazePolicyComponent,
        GazeDeleteAccountComponent,
        GazeSupportComponent
    ],
    bootstrap: [AppComponent], 
    imports: [BrowserModule,
        AppRoutingModule,
        NgbModule,
        NgxDropzoneModule,
        ClipboardModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        FormsModule,
        NgxStripeModule.forChild(),
        NgxStripeModule.forRoot(`${environment.STRIPE_PUBLIC}`),
        BrowserAnimationsModule,
        MatDialogModule,
        MatMenuModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatProgressSpinnerModule
    ], 
    providers: [
        AuthGuardService,
        DatePipe,
        CacheService,
        VimeoService,
        AdminService,
        GetPaymentService,
        PrimeGuard,
        AdminGuard,
        AllaccessguardService,
        SessionService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthHttpInterceptor,
            multi: true,
        }
        // The section below is commented out because Publift ads need to be removed.
        // {
        //   provide: APP_BOOTSTRAP_LISTENER,
        //   useFactory: userServiceLoader,
        //   deps: [UserService],
        //   multi: true,
        // }
        // HelperService
        ,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
